/** @type {string[]} List of `measureNames` that should/could not be used for benchmarking */
export const NON_BENCHMARKING_MEASURES: string[] = ['avgFwci', 'startDate', 'endDate', 'lastUpdate'];

/** @type {number} Max. number of characters that a grant description can have before enabling toggling */
export const GRANT_DESCRIPTION_CHARS_LIMIT = 1000;

/** @type {string[]} List of HTML tags allowed to be in a Grant Description */
export const WHITELISTED_HTML_TAGS_FOR_TEXT_REPRESENTATION = [
  'b',
  'br',
  'del',
  'em',
  'i',
  'li',
  'ol',
  'p',
  's',
  'strike',
  'strong',
  'sub',
  'sup',
  'ul',
];

export const DEFAULT_DATE_FORMAT = 'D MMMM YYYY';
